import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'moment' })
export class MomentPipe implements PipeTransform {

    transform(value: Date | string | number | null | undefined, format?: string, locale?: string, localTimezone?: boolean): string | null {
        if (!value) {
            return null;
        }

        moment.locale(locale);

        const m = moment(value);

        if (!localTimezone) {
            m.utcOffset(0);
        }

        return m.format(format);
    }

}